import React from "react";

import { Stack } from "@mui/material";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import LogoLoadingStill from "@src/sharedComponents/LogoLoadingStill/LogoLoadingStill";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

interface Props {
  closeModal: () => void;
  onContinue: () => void;
  tradingGroupName: string;
  accountName: string;
  isMutating: boolean;
  isOpen: boolean;
  securityCount: number;
}

const DoNotSellWarningModal = (props: Props): JSX.Element => {
  return (
    <Modal
      isOpen={props.isOpen}
      closeModal={props.closeModal}
      modalStyle={{ width: "520px" }}
    >
      <>
        <Text variant="title2" style={{ paddingBottom: 8 }}>
          {`Remove ${props.accountName} from ${props.tradingGroupName}?`}
        </Text>
        <Text color="textSubtle" variant="body" style={{ paddingBottom: 16 }}>
          This account has {props.securityCount}{" "}
          {props.securityCount === 1 ? "security" : "securities"} marked as "Do
          Not Sell".
        </Text>
        <Text color="textSubtle" variant="body" style={{ paddingBottom: 32 }}>
          When you remove this account from the trading group, your Do Not Sell
          securities list will be lost. The model portfolio will no longer be
          applied to the account.
        </Text>
        <Stack direction={"row"} spacing={2}>
          <Button
            sx={{ flex: 1 }}
            style={{ width: "100%" }}
            variant={"outlined"}
            buttonType={"secondary"}
            text={"Cancel"}
            onClick={props.closeModal}
          />
          <Button
            sx={{ flex: 1 }}
            style={{ width: "100%" }}
            variant={"contained"}
            buttonType={"primary"}
            text={"Remove Account"}
            onClick={props.onContinue}
          />
        </Stack>
      </>

      {props.isMutating && <LogoLoadingStill onTop={true} />}
    </Modal>
  );
};

export default DoNotSellWarningModal;
